import { notificationIconService } from '@/services/api/notificationIcon.service';
import { notificationIconModel } from '@/models/api/notificationIcon.model';
import { sharedHelper, alertHelper } from '@/utils';
import i18n from '@/i18n';

export const NOTIFICATION_ICON_MODULE = 'api/notificationIcon';
export const GET_ALL_NOTIFICATION_ICON = 'getAllNotificationIcon';
export const CREATE_NOTIFICATION_ICON = 'createNotificationIcon';
export const GET_NOTIFICATION_ICON = 'getNotificationIcon';
export const UPDATE_NOTIFICATION_ICON = 'updateNotificationIcon';
export const UPDATE_NOTIFICATION_ICON_STATUS = 'updateNotificationIconStatus';
export const DELETE_NOTIFICATION_ICON = 'deleteNotificationIcon';
export const FORCE_DELETE_NOTIFICATION_ICON = 'forceDeleteNotificationIcon';

export const state = {
    list: {
        data: [],
        pagination: {
            pageNumber: 1,
            pageSize: 15,
            lastPage: 1,
            tableRowsCounts: 0,
            total: 0
        }
    },
    details: {},
    status: {
        list: true,
        detail: true,
        save: true
    },
};

function showError(commit, error) {
    commit('failure');
    alertHelper.alertError({ message: sharedHelper.getErrorMessage(error), title: i18n.t('message.error') });
}

export const actions = {
    async [GET_ALL_NOTIFICATION_ICON]({ commit }, { filter }) {
        commit('requesting');
        try {
            const result = await notificationIconService.getAll(filter);
            commit('listSuccess', result);
            return result;
        } catch (error) {
            showError(commit, error);
            return null;
        }
    },
    async [CREATE_NOTIFICATION_ICON]({ commit, dispatch }, { data, filter }) {
        commit('requesting', 'save');
        try {
            const result = await notificationIconService.store(data);
            commit('success');
            alertHelper.alertSuccess({ message: i18n.t('message.createXSuccess', [i18n.t('module.notificationIcon')]) });
            await dispatch(GET_ALL_NOTIFICATION_ICON, { filter });
            return result;
        } catch (error) {
            showError(commit, error);
            return null;
        }
    },
    async [GET_NOTIFICATION_ICON]({ commit }, { uuid }) {
        commit('requesting', 'detail');
        try {
            const result = await notificationIconService.show(uuid);
            commit('detailSuccess', result);
            return result;
        } catch (error) {
            showError(commit, error);
            return null;
        }
    },
    async [UPDATE_NOTIFICATION_ICON]({ commit, dispatch }, { data, filter }) {
        commit('requesting', 'save');
        try {
            const result = await notificationIconService.update(data);
            commit('success');
            alertHelper.alertSuccess({ message: i18n.t('message.updateXSuccess', [i18n.t('module.notificationIcon')]) });
            await dispatch(GET_ALL_NOTIFICATION_ICON, { filter });
            return result;
        } catch (error) {
            showError(commit, error);
            return null;
        }
    },
    async [UPDATE_NOTIFICATION_ICON_STATUS]({ commit, dispatch }, { uuid, isActive, filter }) {
        commit('requesting', 'save');
        try {
            const result = await notificationIconService.updateStatus(uuid, isActive);
            commit('success');
            await dispatch(GET_ALL_NOTIFICATION_ICON, { filter });
            return result;
        } catch (error) {
            showError(commit, error);
            return null;
        }
    },
    async [DELETE_NOTIFICATION_ICON]({ commit, dispatch }, { uuid, filter }) {
        commit('requesting', 'save');
        try {
            const result = await notificationIconService.softDelete(uuid);
            commit('success');
            alertHelper.alertSuccess({ message: i18n.t('message.deleteXSuccess', [i18n.t('module.notificationIcon')]) });
            await dispatch(GET_ALL_NOTIFICATION_ICON, { filter });
            return result;
        } catch (error) {
            showError(commit, error);
            return null;
        }
    },
    async [FORCE_DELETE_NOTIFICATION_ICON]({ commit, dispatch }, { uuid, filter }) {
        commit('requesting', 'save');
        try {
            const result = await notificationIconService.forceDelete(uuid);
            commit('success');
            await dispatch(GET_ALL_NOTIFICATION_ICON, { filter });
            return result;
        } catch (error) {
            showError(commit, error);
            return null;
        }
    },
};

export const mutations = {
    requesting(state, type = 'list') {
        state.status[type] = false;
    },
    listSuccess(state, result) {
        state.list.data = (result?.data || []).map(notificationIconModel);
        state.list.pagination = sharedHelper.apiPaginationAdapter(result?.pagination || {});
        state.status.list = true;
    },
    detailSuccess(state, result) {
        const payload = result?.data || {};
        state.details = notificationIconModel(payload);
        state.status.detail = true;
    },
    success(state) {
        state.status = {
            list: true,
            detail: true,
            save: true
        };
    },
    failure(state) {
        state.status = {
            list: true,
            detail: true,
            save: true
        };
    },
};
